import React from 'react';

import css from './LandingPageIntro.module.css';

/**
 * Renders the shared open editorial header used by PageHop's primary landing pages.
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.description
 * @param {React.Node} [props.eyebrow]
 * @param {boolean} [props.compactTop]
 * @returns {JSX.Element}
 */
const LandingPageIntro = ({ title, description, eyebrow, compactTop = false }) => (
  <header className={compactTop ? `${css.root} ${css.compactTop}` : css.root}>
    <div className={css.content}>
      {eyebrow ? <p className={css.eyebrow}>{eyebrow}</p> : null}
      <h1>{title}</h1>
      <p className={css.description}>{description}</p>
      <span className={css.accent} aria-hidden="true" />
    </div>
  </header>
);

export default LandingPageIntro;
